import '@app-bootstrappers/banner.bootstrapper'
import { queryAll } from 'lambda-dom'
import { construct } from 'ramda'

import { HeaderTheme, setHeaderDisplay, setHeaderTheme } from '@app-components'
import { hashAutoScroll } from '@app-helpers'
import { autoSearch } from '@app-services'
import { StatCard } from './lib'
import './code-of-conduct/code-of-conduct.page'
import './our-structure/our-structure.page'

autoSearch()
hashAutoScroll()

// ------------------------------------------------------------------------------
//      Stats - counters
// ------------------------------------------------------------------------------

queryAll<HTMLElement>('.stat-card--value').forEach(construct(StatCard))

// ------------------------------------------------------------------------------
//      Navigation theme handling
// ------------------------------------------------------------------------------

{
    const heroContainer = document.getElementById('who-we-are-hero')!

    const observer = new IntersectionObserver(([element]) => {
        if (element.intersectionRatio >= 0.85) {
            setHeaderDisplay('none')
            setHeaderTheme(HeaderTheme.TRANSPARENT_WHITE)
        } else {
            setHeaderDisplay('brand-logo')
            setHeaderTheme(HeaderTheme.WHITE)
        }
    }, { threshold: [1, 0.85, 0.1, 0] })

    observer.observe(heroContainer)
}
